export enum CreateCaseStepEnum {
  HELIOS_NUMBER_OBTAINING = 'HELIOS_NUMBER_OBTAINING',
  HELIOS_NUMBER_OBTAINED = 'HELIOS_NUMBER_OBTAINED',
  CASE_CREATED = 'CASE_CREATED',
}
